// wxPay/WxPayOrderEditBase.tsx
import { Col, DatePicker, Form, Input, InputNumber, QRCode, Row, Select, Switch, Tooltip } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

export interface WxPayOrderEditBaseConfig {
    /** 业务 apiId，例如 'wxPayOrder' / 'wxPayOrderBak' */
    apiId: string;
    /** 透传的外部 props（原函数组件 props） */
    outerProps: any;
}

const WxPayOrderEditBase = (config: WxPayOrderEditBaseConfig) => {
    const { apiId, outerProps } = config;
    const { defaultService } = outerProps;

    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);

    const [refundProcessData, setRefundProcess] = useState<any>();
    const [tradeTypeData, setTradeTypeData] = useState<any>();
    const [wxAccountWxPayData, setWxAccountWxPayData] = useState<any>();
    const [wxAccountWxData, setWxAccountWxData] = useState<any>();
    const [payableStatusData, setPayableStatusData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'generalData',
                apiVariable: 'tradeType@refundProcess@payableStatus',
                apiExtend: 'showLists'
            }
        }).then(res => {
            if (res.success) {
                const { tradeType, refundProcess, payableStatus } = res.data;
                setTradeTypeData(tradeType);
                setRefundProcess(refundProcess);
                setPayableStatusData(payableStatus);
            }
        });
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'generalData',
                apiExtend: 'wxAccountList',
                apiData: { slectType: 'wxPay' }
            }
        }).then(res => {
            if (res.success) setWxAccountWxPayData(res.data);
        });
        fetchApi.GET(defaultService, {
            query: {
                apiId: 'generalData',
                apiExtend: 'wxAccountList',
                apiData: { slectType: 'wx@wxMiniApp' }
            }
        }).then(res => {
            if (res.success) setWxAccountWxData(res.data);
        });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...outerProps,
        form,
        apiId,                               // ← 变量替换硬编码
        serviceId: 'pay',
        dateOptions: {
            columnNames: ['tradeTime']
        },
        displayOptions: {
            width: 900
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={6}>
                        <Form.Item label="id" name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="交易类型"
                            name="tradeTypeId"
                            rules={[{ required: true, message: '交易类型!' }]}>
                            <Select
                                showSearch
                                placeholder="交易类型"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(tradeTypeData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label="来源"
                            name="wxSourceId"
                            rules={[{ required: true, message: '微信来源"!' }]}>
                            <Select
                                showSearch
                                placeholder="微信来源"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(wxAccountWxData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="支付"
                            name="wxPayId"
                            rules={[{ required: true, message: '微信支付!' }]}>
                            <Select
                                showSearch
                                placeholder="微信支付"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(wxAccountWxPayData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="交易单号" name="transactionNo">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item label="支付信息" name="payInfo">
                            <Tooltip placement="topLeft" title={form.getFieldValue('payInfo')}>
                                <Input
                                    value={Form.useWatch('payInfo', form)}
                                    onChange={(e) => form.setFieldsValue({ payInfo: e.target.value })}
                                />
                            </Tooltip>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="wxSPOpenId" name="wxSPOpenId" tooltip='服务商的用户openId'>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="随机字符" name="nonceStr">
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="wxOpenId" name="wxOpenId" tooltip='商户/子商户的用户openId'>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item label="交易时间" name="tradeTime">
                            <DatePicker format="YYYY-MM-DD HH:mm:ss" />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="交易成功"
                            name="isTransactionSuccessful"
                            valuePropName="checked"
                            initialValue={false}>
                            <Switch checked={false} checkedChildren="是" unCheckedChildren="否" disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="金额"
                            name="payAmount"
                            rules={[{ required: true, message: '请输入支付金额!' }]}>
                            <InputNumber style={{ width: 85 }} />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item label="未退款" name="unreimbursedAmount">
                            <InputNumber style={{ width: 85 }} />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="退款进程"
                            name="refundProcessId"
                            rules={[{ required: true, message: '退款进程!' }]}>
                            <Select
                                showSearch
                                placeholder="退款进程"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(refundProcessData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item label="付款状态" name="payableStatusId">
                            <Select
                                showSearch
                                placeholder="付款状态"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(payableStatusData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            <Switch checked={true} checkedChildren="启用" unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                    {form.getFieldValue('tradeTypeId') === 'NATIVE' ? (
                        <Col span={6}>
                            <Form.Item
                                label="扫码支付"
                                name="payInfo"
                                valuePropName="checked"
                                initialValue={true}>
                                <QRCode value={form.getFieldValue('payInfo')} />
                            </Form.Item>
                        </Col>
                    ) : ''}
                </Row>
            )
        }
    };

    return <WebEditUniversal ref={ref} {...extendProps} />;
};

export default WxPayOrderEditBase;